import { render, staticRenderFns } from "./CreateRoleButton.vue?vue&type=template&id=85bfa90a&scoped=true&"
import script from "./CreateRoleButton.vue?vue&type=script&lang=js&"
export * from "./CreateRoleButton.vue?vue&type=script&lang=js&"
import style0 from "./CreateRoleButton.vue?vue&type=style&index=0&id=85bfa90a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bfa90a",
  null
  
)

export default component.exports